import { Stack } from 'components/Stack'
import Image, { StaticImageData } from 'next/image'
import { Text } from 'components/Text'
import { FooterMessageRoot, FooterCard, TextColumn, FooterBanner } from './FooterMessage.styles'
import { Box } from 'components/Box'
import Trans from 'next-translate/Trans'
import { TranslationKeys } from 'locales/translationKeys'
import { useTranslation } from 'hooks/useTranslation'

type FooterMessageProps = {
  imageAlt: TranslationKeys
  imageSrc: StaticImageData
  title: TranslationKeys
  subtext: TranslationKeys
}

export const FooterMessage = (props: FooterMessageProps) => {
  const { imageSrc, imageAlt, title, subtext } = props
  const { t } = useTranslation()
  return (
    <FooterMessageRoot>
      <FooterCard>
        <Stack gap="2" justifyContent="flex-start" alignItems="center">
          <Box className="d-only">
            <Image src={imageSrc} alt={imageAlt} />
          </Box>
          <TextColumn direction="column" alignItems="flex-start">
            <Stack gap='0' justifyContent="flex-start" alignItems="center">
              <Box className="m-only">
                <Image src={imageSrc} alt={imageAlt} />
              </Box>
              <Text transform="uppercase" weight="regular" color="primary-700" size="h3" font="label">
                {t(title)}
              </Text>
            </Stack>
            <Text color="accent-black" size="body">
              <Trans i18nKey={subtext} components={{'span': <strong />}}/>
            </Text>
          </TextColumn>
        </Stack>
      </FooterCard>
      <FooterBanner />
    </FooterMessageRoot>
  )
}
